// Initalize slider globally
let slider;

// Trigger Shopify's price filter form submission
function triggerPriceFilter() {
  const shopifyMinPriceInput = document.querySelector(
    ".js-price-range-filter__input-min"
  );
  const shopifyMaxPriceInput = document.querySelector(
    ".js-price-range-filter__input-max"
  );
  const minPriceInput = document.getElementById("min-price");
  const maxPriceInput = document.getElementById("max-price");
  const event = new Event("input", { bubbles: true });
  shopifyMinPriceInput.dispatchEvent(event);
  shopifyMaxPriceInput.dispatchEvent(event);
  minPriceInput.dispatchEvent(event);
  maxPriceInput.dispatchEvent(event);
}

function getInitialValues() {
  const minPriceInput = document.getElementById("min-price");
  const maxPriceInput = document.getElementById("max-price");
  const urlParams = new URLSearchParams(window.location.search);
  const minPrice =
    urlParams.get("filter.v.price.gte") || minPriceInput.dataset.min || 0;
  const maxPrice =
    urlParams.get("filter.v.price.lte") || maxPriceInput.dataset.max || 10000;
  return [parseFloat(minPrice), parseFloat(maxPrice)];
}

function SliderInitilaization() {
  const minPriceInput = document.getElementById("min-price");
  const maxPriceInput = document.getElementById("max-price");
  if (maxPriceInput && minPriceInput) {
    const maxPrice = parseFloat(maxPriceInput.getAttribute("data-max"));
    

    const shopifyMinPriceInput = document.querySelector(
      ".js-price-range-filter__input-min"
    );
    const shopifyMaxPriceInput = document.querySelector(
      ".js-price-range-filter__input-max"
    );

    // Update slider and Shopify price inputs when min input field changes
    minPriceInput.addEventListener("change", function () {
      slider.noUiSlider.set([this.value, null]);
      shopifyMinPriceInput.value = this.value;
      triggerPriceFilter();
    });

    // Update slider and Shopify price inputs when max input field changes
    maxPriceInput.addEventListener("change", function () {
      slider.noUiSlider.set([null, this.value]);
      shopifyMaxPriceInput.value = this.value;
      triggerPriceFilter();
    });

    // Initial slider setup
    initializeSlider(0, maxPrice);
  }
}

function initializeSlider(min, max) {
  const priceSlider = document.getElementById("price-slider");
  const minPriceInput = document.getElementById("min-price");
  const maxPriceInput = document.getElementById("max-price");
  const shopifyMinPriceInput = document.querySelector(
    ".js-price-range-filter__input-min"
  );
  const shopifyMaxPriceInput = document.querySelector(
    ".js-price-range-filter__input-max"
  );
  const [initialMin, initialMax] = getInitialValues();
  const start = [initialMin, initialMax];
  // If slider already exists, destroy it
  if (slider && slider.noUiSlider) {
    slider.noUiSlider.destroy();
  }

  // Initialize the slider
  // noUiSlider.create(priceSlider, {
  //   start: start,
  //   connect: true,
  //   range: {
  //     min: min,
  //     max: max,
  //   },
  // });


noUiSlider.create(priceSlider, {
  start: start,
  connect: true,
  range: {
    min: min,
    max: max,
  }
});


  slider = priceSlider; // Store reference to the slider

  // Update input fields and Shopify price inputs when slider values change
  slider.noUiSlider.on("update", function (values, handle) {
    const value = values[handle];
    if (handle === 0) {
      minPriceInput.value = value;
      shopifyMinPriceInput.value = value;
    } else {
      maxPriceInput.value = value;
      shopifyMaxPriceInput.value = value;
    }
  });

  // Add event listener to update Shopify's price filter
  slider.noUiSlider.on("change", triggerPriceFilter);
}

Shopify.initialPriceFilterSlider = function () {
  SliderInitilaization();
};

document.addEventListener("DOMContentLoaded", () => {
  SliderInitilaization();
});
